// extracted by mini-css-extract-plugin
export default {"pageWrapper":"OffersTabContent-module__pageWrapper--IPddQ","content":"OffersTabContent-module__content--xW0I8","cardsList":"OffersTabContent-module__cardsList--ATzxA"};